import { useNavigate } from 'react-router'
import { toast } from 'sonner'

import { PageHeader } from '@/components/ds'
import { useSetPageHeader } from '@/contexts/PageHeaderContext'
import { StandaloneParticipantForm } from '@/forms/ParticipantForm/StandaloneParticipantForm'

export default function ContactNewPage() {
  const navigate = useNavigate()
  const title = 'Nový kontakt'

  useSetPageHeader({
    breadcrumbs: [
      { href: '/contacts', children: 'Kontakty' },
      { href: '/contact/new', children: title },
    ],
  })

  return (
    <>
      <title>{title}</title>
      <div className="mx-auto w-full max-w-[1280px]">
        <PageHeader title={title} description="Odběratel nebo dodavatel. Po uložení ho vyberete při vystavení dokladu." />

        <StandaloneParticipantForm
          type="customer"
          showAccountNumber
          submitLabel="Vytvořit kontakt"
          onCancel={() => navigate(-1)}
          onSuccess={(data) => {
            toast.success('Kontakt byl vytvořen.')
            navigate(data?.id ? `/contact/${data.id}` : '/contacts')
          }}
        />
      </div>
    </>
  )
}
